import React from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import RoomsSection from './components/RoomsSection';
import AmenitiesSection from './components/AmenitiesSection';
import PoliciesSection from './components/PoliciesSection';
import LocationSection from './components/LocationSection';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App min-h-screen bg-brand-bg text-brand-text font-body">
      <Header />
      <main id="home" className="pt-20">
        <HeroSection />
        <RoomsSection />
        <AmenitiesSection />
        <PoliciesSection />
        <LocationSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
